<template>
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M33.8 11H18.6C17.5922 11 16.6256 11.4004 15.913 12.113C15.2003 12.8256 14.8 13.7922 14.8 14.8V45.2C14.8 46.2078 15.2003 47.1744 15.913 47.887C16.6256 48.5996 17.5922 49 18.6 49H41.4C42.4078 49 43.3744 48.5996 44.087 47.887C44.7996 47.1744 45.2 46.2078 45.2 45.2V22.4L33.8 11Z"
        stroke="#43D3B3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M34.3429 11V22.9429H45.2" stroke="#43D3B3" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M37.6 31.6286H22.4" stroke="#43D3B3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M37.6 39.2286H22.4" stroke="#43D3B3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M26.7428 24.0286H24.5714H22.4" stroke="#43D3B3" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round"/>
  </svg>

</template>

<script>
export default {
  name: 'Conclusion',
  props: {},
  computed: {}
};
</script>
<style scoped lang="scss">

</style>
